import DefaultDetail from "@Common/DefaultDetail";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { computed } from "mobx";

const BucketAddDetail = inject("mainStore")(
    observer(({ mainStore }) => {
        const { secondParam } = useParams();
        const ref = useRef();
        const detailData = computed(() => mainStore.getMainStore("detailData")).get();
        // const [disabled, setDisabled] = useState(false);

        // useEffect(() => {
        //     setDisabled(ref?.current?.disabledUpdataBtn);
        // }, [detailData]);

        let inputs = [
            {
                blockName: secondParam === "add" ? "Корзины / " : `${detailData.title}`,
                blockSub: secondParam === "add" ? { name: "Добавить", style: { color: "#556376" } } : null,
                inputs: {
                    vendorId: {
                        label: "Выберите вендор",
                        type: "selectSuggest",
                        required: true,
                        apiUrl: "/promo/suggest_list?collection=vendors&project[_id]=1&project[code]=1&project[name]=1&sortField=name&sortOrder=asc",
                        dataKey: "suggest.vendors_suggest",
                        refetchOnMountData: true,
                        optionValue: "_id",
                        optionLabel: "name",
                        placeholder: "Выберите вендор",
                        selectedItemKey: "_id",
                        appendTo: "self",
                        addClass: "full",
                    },
                    title: { label: "Укажите название корзины", type: "string", required: true, translitTo: "code", placeholder: "Введите название корзины" },
                    code: { label: "Код", type: "string", required: true, placeholder: "Код генерируется автоматически" },
                    codesValidityDate: { label: "Укажите срок действия кодов", type: "date", required: true },
                    miniDescription: { label: "Добавьте описание для телеграмм бота", type: "textArea", addClass: "full", placeholder: "Опишите тут понятное сообщение для оповещений в телеграмм боте", maxLength: 300, count: true },

                    bucketUpload: { type: "bucketUpload" },
                    bucketDetail: { type: "bucketDetail" },
                },
            },
        ];

        if (secondParam === "add") {
            inputs[0].inputs.bucketDetail.type = null;
            inputs[0].inputs.bucketUpload = {
                type: "btn",
                label: "Сохранить корзину",
                addClass: "full",

                severity: "success",
                onClick: (e) => {
                    // второй аргумент в функции отвечает за сохранения корзины в черновик
                    ref.current.handleSaveAndUpdate(e, true);
                },
            };
        }

        return (
            <DefaultDetail
                title={"Корзины / Офферы"}
                apiUrl={secondParam === "add" ? "/promo/buckets" : `/promo/buckets/${secondParam}`}
                dataKey={secondParam}
                scopes={false}
                inputs={inputs}
                titleList={"title"}
                titleRight={"корзину"}
                urlUpload={"project"}
                page={"project"}
                logging={true}
                ref={ref}
            />
        );
    }),
);

export default BucketAddDetail;
